import React, { useRef } from "react";
import "../../../../assets/scss/components/sections/home/testimonials.scss";
import Slider from "react-slick";
import Masonry from "react-masonry-css";
import { Container, Image } from "react-bootstrap";

import star from "../../../../assets/images/home/star.svg";
import prev from "../../../../assets/images/home/left.svg";
import next from "../../../../assets/images/home/right.svg";
import testimonials from "./testimonial_data.json";
import Heading from "../../../templates/heading";

const TestimonialsSimple = () => {
  const sliderRef = useRef(null);
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 573,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendDots: (dots) => (
        <div
            style={{
              position: "relative",
            }}
        >
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
    ),
    customPaging: (i) => (
        <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "gray",
            }}
        />
    ),
  };

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    768: 2,
  };

  const renderRating = (rating) => {
    return Array.from({ length: rating }, (_, index) => (
        <span key={index}>
        <Image src={star} />
      </span>
    ));
  };

  const getImageSource = (index) => {
    return require(`../../../../assets/images/home/test-img-${index + 1}.png`);
  };

  return (
      <div className="testimonials-section">
        <Container>
          <Heading
              heading="What People are Saying?"
              text="Trusted by thousands of professionals — here's how Resumly helped them succeed"
          />
          <Masonry
              breakpointCols={breakpointColumnsObj}
              className="testimonials-grid d-none d-md-flex"
              columnClassName="masonry-column"
          >
            {testimonials.testimonials.map((testimonial, index) => (
                <div className="testimonial-box" key={index}>
                  <div className="testimonial-header">
                    <div className="display-img">
                      <Image
                          src={getImageSource(index)}
                          alt={`testimonial-${index + 1}`}
                      />
                    </div>
                    <div className="header-text">
                      <h3 className="user-name">{testimonial.user_name}</h3>
                      <p className="user-role">{testimonial.user_role}</p>
                    </div>
                  </div>
                  <div className="rating">{renderRating(testimonial.rating)}</div>
                  <div className="testimonial-body">
                    <p className="testimonial-text paragraph-small-regular">
                      {testimonial.testimonial_text}
                    </p>
                  </div>
                </div>
            ))}
          </Masonry>

          <div className="testimonial-slider d-block d-md-none">
            <Slider {...sliderSettings} ref={sliderRef}>
              {testimonials.testimonials.map((testimonial, index) => (
                  <div className="testimonial-box" key={index}>
                    <div className="testimonial-header">
                      <div className="display-img">
                        <Image
                            src={getImageSource(index)}
                            alt={`testimonial-${index + 1}`}
                        />
                      </div>
                      <div className="header-text">
                        <h3 className="user-name">{testimonial.user_name}</h3>
                        <p className="user-role">{testimonial.user_role}</p>
                      </div>
                    </div>
                    <div className="rating">{renderRating(testimonial.rating)}</div>
                    <div className="testimonial-body">
                      <p className="testimonial-text paragraph-small-regular">
                        {testimonial.testimonial_text}
                      </p>
                    </div>
                  </div>
              ))}
            </Slider>
            <div className="slides-navigation-btns">
              <Image
                  src={prev}
                  className="me-2"
                  onClick={() => sliderRef.current.slickPrev()}
              />
              <Image src={next} onClick={() => sliderRef.current.slickNext()} />
            </div>
          </div>
        </Container>
      </div>
  );
};

export default TestimonialsSimple;